import * as i0 from '@angular/core';
import { Injectable } from '@angular/core';
import { map, catchError, mapTo } from 'rxjs/operators';
import * as i1 from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { throwError, of } from 'rxjs';

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var CancellationRequestReason = /*#__PURE__*/function (CancellationRequestReason) {
  CancellationRequestReason[CancellationRequestReason["CANCELLATION_REQUEST_REASON_UNSET"] = 0] = "CANCELLATION_REQUEST_REASON_UNSET";
  CancellationRequestReason[CancellationRequestReason["CANCELLATION_REQUEST_REASON_OTHER"] = 1] = "CANCELLATION_REQUEST_REASON_OTHER";
  return CancellationRequestReason;
}(CancellationRequestReason || {});
var CancellationRequestStatus = /*#__PURE__*/function (CancellationRequestStatus) {
  CancellationRequestStatus[CancellationRequestStatus["CANCELLATION_REQUEST_STATUS_UNSET"] = 0] = "CANCELLATION_REQUEST_STATUS_UNSET";
  CancellationRequestStatus[CancellationRequestStatus["CANCELLATION_REQUEST_STATUS_REQUESTED"] = 1] = "CANCELLATION_REQUEST_STATUS_REQUESTED";
  CancellationRequestStatus[CancellationRequestStatus["CANCELLATION_REQUEST_STATUS_RESOLVED"] = 2] = "CANCELLATION_REQUEST_STATUS_RESOLVED";
  CancellationRequestStatus[CancellationRequestStatus["CANCELLATION_REQUEST_STATUS_DECLINED"] = 3] = "CANCELLATION_REQUEST_STATUS_DECLINED";
  return CancellationRequestStatus;
}(CancellationRequestStatus || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var AccountField = /*#__PURE__*/function (AccountField) {
  AccountField[AccountField["ACCOUNT_FIELD_CREATED"] = 0] = "ACCOUNT_FIELD_CREATED";
  AccountField[AccountField["ACCOUNT_FIELD_UPDATED"] = 1] = "ACCOUNT_FIELD_UPDATED";
  AccountField[AccountField["ACCOUNT_FIELD_NAME"] = 2] = "ACCOUNT_FIELD_NAME";
  AccountField[AccountField["ACCOUNT_FIELD_CITY"] = 3] = "ACCOUNT_FIELD_CITY";
  AccountField[AccountField["ACCOUNT_FIELD_STATE"] = 4] = "ACCOUNT_FIELD_STATE";
  return AccountField;
}(AccountField || {});
var AccountsArchived = /*#__PURE__*/function (AccountsArchived) {
  AccountsArchived[AccountsArchived["ACCOUNTS_ARCHIVED_INVALID"] = 0] = "ACCOUNTS_ARCHIVED_INVALID";
  AccountsArchived[AccountsArchived["ACCOUNTS_ARCHIVED_ALL"] = 1] = "ACCOUNTS_ARCHIVED_ALL";
  AccountsArchived[AccountsArchived["ACCOUNTS_ARCHIVED_TRUE"] = 2] = "ACCOUNTS_ARCHIVED_TRUE";
  AccountsArchived[AccountsArchived["ACCOUNTS_ARCHIVED_FALSE"] = 3] = "ACCOUNTS_ARCHIVED_FALSE";
  return AccountsArchived;
}(AccountsArchived || {});
var SortDirection$1 = /*#__PURE__*/function (SortDirection) {
  SortDirection[SortDirection["SORT_DIRECTION_UNSET"] = 0] = "SORT_DIRECTION_UNSET";
  SortDirection[SortDirection["SORT_DIRECTION_ASCENDING"] = 1] = "SORT_DIRECTION_ASCENDING";
  SortDirection[SortDirection["SORT_DIRECTION_DESCENDING"] = 2] = "SORT_DIRECTION_DESCENDING";
  return SortDirection;
}(SortDirection$1 || {});
// *********************************

function enumStringToValue$7(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class FieldMask {
  static fromProto(proto) {
    let m = new FieldMask();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.paths !== 'undefined') {
      toReturn['paths'] = this.paths;
    }
    return toReturn;
  }
}
function enumStringToValue$6(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class Access {
  static fromProto(proto) {
    let m = new Access();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.scope !== 'undefined') {
      toReturn['scope'] = this.scope;
    }
    if (typeof this.public !== 'undefined') {
      toReturn['public'] = this.public;
    }
    return toReturn;
  }
}
function enumStringToValue$5(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class Salesperson {
  static fromProto(proto) {
    let m = new Salesperson();
    m = Object.assign(m, proto);
    if (proto.lastLogin) {
      m.lastLogin = new Date(proto.lastLogin);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.salespersonId !== 'undefined') {
      toReturn['salespersonId'] = this.salespersonId;
    }
    if (typeof this.firstName !== 'undefined') {
      toReturn['firstName'] = this.firstName;
    }
    if (typeof this.lastName !== 'undefined') {
      toReturn['lastName'] = this.lastName;
    }
    if (typeof this.email !== 'undefined') {
      toReturn['email'] = this.email;
    }
    if (typeof this.phoneNumber !== 'undefined') {
      toReturn['phoneNumber'] = this.phoneNumber;
    }
    if (typeof this.unifiedUserId !== 'undefined') {
      toReturn['unifiedUserId'] = this.unifiedUserId;
    }
    if (typeof this.countryCode !== 'undefined') {
      toReturn['countryCode'] = this.countryCode;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    if (typeof this.photoUrlHttps !== 'undefined') {
      toReturn['photoUrlHttps'] = this.photoUrlHttps;
    }
    if (typeof this.lastLogin !== 'undefined' && this.lastLogin !== null) {
      toReturn['lastLogin'] = 'toApiJson' in this.lastLogin ? this.lastLogin.toApiJson() : this.lastLogin;
    }
    return toReturn;
  }
}
function enumStringToValue$4(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class Contact {
  static fromProto(proto) {
    let m = new Contact();
    m = Object.assign(m, proto);
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.contactId !== 'undefined') {
      toReturn['contactId'] = this.contactId;
    }
    if (typeof this.notes !== 'undefined') {
      toReturn['notes'] = this.notes;
    }
    if (typeof this.firstName !== 'undefined') {
      toReturn['firstName'] = this.firstName;
    }
    if (typeof this.lastName !== 'undefined') {
      toReturn['lastName'] = this.lastName;
    }
    if (typeof this.title !== 'undefined') {
      toReturn['title'] = this.title;
    }
    if (typeof this.contactEmail !== 'undefined') {
      toReturn['contactEmail'] = this.contactEmail;
    }
    if (typeof this.phoneNumber !== 'undefined') {
      toReturn['phoneNumber'] = this.phoneNumber;
    }
    if (typeof this.phoneExtension !== 'undefined') {
      toReturn['phoneExtension'] = this.phoneExtension;
    }
    if (typeof this.accountIds !== 'undefined') {
      toReturn['accountIds'] = this.accountIds;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.phoneNumberCountry !== 'undefined') {
      toReturn['phoneNumberCountry'] = this.phoneNumberCountry;
    }
    return toReturn;
  }
}
function enumStringToValue$3(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class ActionList {
  static fromProto(proto) {
    let m = new ActionList();
    m = Object.assign(m, proto);
    if (proto.accounts) {
      m.accounts = parseInt(proto.accounts, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.accounts !== 'undefined') {
      toReturn['accounts'] = this.accounts;
    }
    if (typeof this.inProgress !== 'undefined') {
      toReturn['inProgress'] = this.inProgress;
    }
    return toReturn;
  }
}
function enumStringToValue$2(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class Business {
  static fromProto(proto) {
    let m = new Business();
    m = Object.assign(m, proto);
    if (proto.updated) {
      m.updated = new Date(proto.updated);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.updated !== 'undefined' && this.updated !== null) {
      toReturn['updated'] = 'toApiJson' in this.updated ? this.updated.toApiJson() : this.updated;
    }
    return toReturn;
  }
}
function enumStringToValue$1(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class CancellationRequest {
  static fromProto(proto) {
    let m = new CancellationRequest();
    m = Object.assign(m, proto);
    if (proto.status) {
      m.status = enumStringToValue$1(CancellationRequestStatus, proto.status);
    }
    if (proto.reason) {
      m.reason = enumStringToValue$1(CancellationRequestReason, proto.reason);
    }
    if (proto.requestCreatedDate) {
      m.requestCreatedDate = new Date(proto.requestCreatedDate);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.cancellationRequestId !== 'undefined') {
      toReturn['cancellationRequestId'] = this.cancellationRequestId;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.lineItemId !== 'undefined') {
      toReturn['lineItemId'] = this.lineItemId;
    }
    if (typeof this.requestingUserId !== 'undefined') {
      toReturn['requestingUserId'] = this.requestingUserId;
    }
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    if (typeof this.reason !== 'undefined') {
      toReturn['reason'] = this.reason;
    }
    if (typeof this.message !== 'undefined') {
      toReturn['message'] = this.message;
    }
    if (typeof this.requestCreatedDate !== 'undefined' && this.requestCreatedDate !== null) {
      toReturn['requestCreatedDate'] = 'toApiJson' in this.requestCreatedDate ? this.requestCreatedDate.toApiJson() : this.requestCreatedDate;
    }
    return toReturn;
  }
}
function enumStringToValue(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class AccountLatestSalesActivity {
  static fromProto(proto) {
    let m = new AccountLatestSalesActivity();
    m = Object.assign(m, proto);
    if (proto.lastActivityDate) {
      m.lastActivityDate = new Date(proto.lastActivityDate);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountId !== 'undefined') {
      toReturn['accountId'] = this.accountId;
    }
    if (typeof this.lastActivityDate !== 'undefined' && this.lastActivityDate !== null) {
      toReturn['lastActivityDate'] = 'toApiJson' in this.lastActivityDate ? this.lastActivityDate.toApiJson() : this.lastActivityDate;
    }
    return toReturn;
  }
}
class AddAccountsToActionListRequest {
  static fromProto(proto) {
    let m = new AddAccountsToActionListRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    if (typeof this.listName !== 'undefined') {
      toReturn['listName'] = this.listName;
    }
    if (typeof this.accountGroupIds !== 'undefined') {
      toReturn['accountGroupIds'] = this.accountGroupIds;
    }
    return toReturn;
  }
}
class AddAccountsToActionListResponse {
  static fromProto(proto) {
    let m = new AddAccountsToActionListResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.actionListId !== 'undefined') {
      toReturn['actionListId'] = this.actionListId;
    }
    return toReturn;
  }
}
class AddContactToCampaignRequest {
  static fromProto(proto) {
    let m = new AddContactToCampaignRequest();
    m = Object.assign(m, proto);
    if (proto.contact) {
      m.contact = AddContactToCampaignRequestRecipient.fromProto(proto.contact);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.campaignId !== 'undefined') {
      toReturn['campaignId'] = this.campaignId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    if (typeof this.senderUnifiedUserId !== 'undefined') {
      toReturn['senderUnifiedUserId'] = this.senderUnifiedUserId;
    }
    if (typeof this.contact !== 'undefined' && this.contact !== null) {
      toReturn['contact'] = 'toApiJson' in this.contact ? this.contact.toApiJson() : this.contact;
    }
    return toReturn;
  }
}
class CreateContactRequest {
  static fromProto(proto) {
    let m = new CreateContactRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    if (typeof this.accountGroupIds !== 'undefined') {
      toReturn['accountGroupIds'] = this.accountGroupIds;
    }
    if (typeof this.phoneNumber !== 'undefined') {
      toReturn['phoneNumber'] = this.phoneNumber;
    }
    if (typeof this.phoneNumberCountry !== 'undefined') {
      toReturn['phoneNumberCountry'] = this.phoneNumberCountry;
    }
    if (typeof this.phoneNumberExtension !== 'undefined') {
      toReturn['phoneNumberExtension'] = this.phoneNumberExtension;
    }
    if (typeof this.email !== 'undefined') {
      toReturn['email'] = this.email;
    }
    if (typeof this.firstName !== 'undefined') {
      toReturn['firstName'] = this.firstName;
    }
    if (typeof this.lastName !== 'undefined') {
      toReturn['lastName'] = this.lastName;
    }
    if (typeof this.title !== 'undefined') {
      toReturn['title'] = this.title;
    }
    if (typeof this.notes !== 'undefined') {
      toReturn['notes'] = this.notes;
    }
    return toReturn;
  }
}
class CreateContactResponse {
  static fromProto(proto) {
    let m = new CreateContactResponse();
    m = Object.assign(m, proto);
    if (proto.contact) {
      m.contact = Contact.fromProto(proto.contact);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.contact !== 'undefined' && this.contact !== null) {
      toReturn['contact'] = 'toApiJson' in this.contact ? this.contact.toApiJson() : this.contact;
    }
    return toReturn;
  }
}
class CreateRequest {
  static fromProto(proto) {
    let m = new CreateRequest();
    m = Object.assign(m, proto);
    if (proto.status) {
      m.status = enumStringToValue(CancellationRequestStatus, proto.status);
    }
    if (proto.reason) {
      m.reason = enumStringToValue(CancellationRequestReason, proto.reason);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.lineItemId !== 'undefined') {
      toReturn['lineItemId'] = this.lineItemId;
    }
    if (typeof this.requestingUserId !== 'undefined') {
      toReturn['requestingUserId'] = this.requestingUserId;
    }
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    if (typeof this.reason !== 'undefined') {
      toReturn['reason'] = this.reason;
    }
    if (typeof this.message !== 'undefined') {
      toReturn['message'] = this.message;
    }
    return toReturn;
  }
}
class CreateSalespersonForUserRequest {
  static fromProto(proto) {
    let m = new CreateSalespersonForUserRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.authCheckOnly !== 'undefined') {
      toReturn['authCheckOnly'] = this.authCheckOnly;
    }
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    if (typeof this.isSalesManager !== 'undefined') {
      toReturn['isSalesManager'] = this.isSalesManager;
    }
    return toReturn;
  }
}
class CreateSalespersonForUserResponse {
  static fromProto(proto) {
    let m = new CreateSalespersonForUserResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    return toReturn;
  }
}
class DateRangeFilter {
  static fromProto(proto) {
    let m = new DateRangeFilter();
    m = Object.assign(m, proto);
    if (proto.beginRange) {
      m.beginRange = new Date(proto.beginRange);
    }
    if (proto.endRange) {
      m.endRange = new Date(proto.endRange);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.beginRange !== 'undefined' && this.beginRange !== null) {
      toReturn['beginRange'] = 'toApiJson' in this.beginRange ? this.beginRange.toApiJson() : this.beginRange;
    }
    if (typeof this.endRange !== 'undefined' && this.endRange !== null) {
      toReturn['endRange'] = 'toApiJson' in this.endRange ? this.endRange.toApiJson() : this.endRange;
    }
    return toReturn;
  }
}
class DeleteContactRequest {
  static fromProto(proto) {
    let m = new DeleteContactRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    if (typeof this.contactId !== 'undefined') {
      toReturn['contactId'] = this.contactId;
    }
    return toReturn;
  }
}
class EffortAggregate {
  static fromProto(proto) {
    let m = new EffortAggregate();
    m = Object.assign(m, proto);
    if (proto.efforts) {
      m.efforts = Object.keys(proto.efforts).reduce((obj, k) => {
        obj[k] = parseInt(proto.efforts[k], 10);
        return obj;
      }, {});
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.efforts !== 'undefined' && this.efforts !== null) {
      toReturn['efforts'] = 'toApiJson' in this.efforts ? this.efforts.toApiJson() : this.efforts;
    }
    return toReturn;
  }
}
class EffortAggregateEffortsEntry {
  static fromProto(proto) {
    let m = new EffortAggregateEffortsEntry();
    m = Object.assign(m, proto);
    if (proto.value) {
      m.value = parseInt(proto.value, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.key !== 'undefined') {
      toReturn['key'] = this.key;
    }
    if (typeof this.value !== 'undefined') {
      toReturn['value'] = this.value;
    }
    return toReturn;
  }
}
class GetAccountPrimaryContactRequest {
  static fromProto(proto) {
    let m = new GetAccountPrimaryContactRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountId !== 'undefined') {
      toReturn['accountId'] = this.accountId;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    return toReturn;
  }
}
class GetAccountPrimaryContactResponse {
  static fromProto(proto) {
    let m = new GetAccountPrimaryContactResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.contactId !== 'undefined') {
      toReturn['contactId'] = this.contactId;
    }
    return toReturn;
  }
}
class GetContactByIDRequest {
  static fromProto(proto) {
    let m = new GetContactByIDRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.contactId !== 'undefined') {
      toReturn['contactId'] = this.contactId;
    }
    return toReturn;
  }
}
class GetContactResponse {
  static fromProto(proto) {
    let m = new GetContactResponse();
    m = Object.assign(m, proto);
    if (proto.contact) {
      m.contact = Contact.fromProto(proto.contact);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.contact !== 'undefined' && this.contact !== null) {
      toReturn['contact'] = 'toApiJson' in this.contact ? this.contact.toApiJson() : this.contact;
    }
    return toReturn;
  }
}
class GetContactsForAccountsRequest {
  static fromProto(proto) {
    let m = new GetContactsForAccountsRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    if (typeof this.accountIds !== 'undefined') {
      toReturn['accountIds'] = this.accountIds;
    }
    return toReturn;
  }
}
class GetContactsForAccountsResponse {
  static fromProto(proto) {
    let m = new GetContactsForAccountsResponse();
    m = Object.assign(m, proto);
    if (proto.contacts) {
      m.contacts = proto.contacts.map(Contact.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.contacts !== 'undefined' && this.contacts !== null) {
      toReturn['contacts'] = 'toApiJson' in this.contacts ? this.contacts.toApiJson() : this.contacts;
    }
    return toReturn;
  }
}
class GetMultiCampaignsRequest {
  static fromProto(proto) {
    let m = new GetMultiCampaignsRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.campaignIds !== 'undefined') {
      toReturn['campaignIds'] = this.campaignIds;
    }
    return toReturn;
  }
}
class GetMultiCampaignsResponse {
  static fromProto(proto) {
    let m = new GetMultiCampaignsResponse();
    m = Object.assign(m, proto);
    if (proto.campaigns) {
      m.campaigns = proto.campaigns.map(SalesCampaign.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.campaigns !== 'undefined' && this.campaigns !== null) {
      toReturn['campaigns'] = 'toApiJson' in this.campaigns ? this.campaigns.toApiJson() : this.campaigns;
    }
    return toReturn;
  }
}
class GetMultiOpportunityEffortsRequest {
  static fromProto(proto) {
    let m = new GetMultiOpportunityEffortsRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.opportunityIds !== 'undefined') {
      toReturn['opportunityIds'] = this.opportunityIds;
    }
    return toReturn;
  }
}
class GetMultiOpportunityEffortsResponse {
  static fromProto(proto) {
    let m = new GetMultiOpportunityEffortsResponse();
    m = Object.assign(m, proto);
    if (proto.opportunityEfforts) {
      m.opportunityEfforts = Object.keys(proto.opportunityEfforts).reduce((obj, k) => {
        obj[k] = EffortAggregate.fromProto(proto.opportunityEfforts[k]);
        return obj;
      }, {});
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.opportunityEfforts !== 'undefined' && this.opportunityEfforts !== null) {
      toReturn['opportunityEfforts'] = 'toApiJson' in this.opportunityEfforts ? this.opportunityEfforts.toApiJson() : this.opportunityEfforts;
    }
    return toReturn;
  }
}
class GetSalesActivityForAccountsRequest {
  static fromProto(proto) {
    let m = new GetSalesActivityForAccountsRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    if (typeof this.accountIds !== 'undefined') {
      toReturn['accountIds'] = this.accountIds;
    }
    return toReturn;
  }
}
class GetSalesActivityForAccountsResponse {
  static fromProto(proto) {
    let m = new GetSalesActivityForAccountsResponse();
    m = Object.assign(m, proto);
    if (proto.accountsLatestSalesActivity) {
      m.accountsLatestSalesActivity = proto.accountsLatestSalesActivity.map(AccountLatestSalesActivity.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountsLatestSalesActivity !== 'undefined' && this.accountsLatestSalesActivity !== null) {
      toReturn['accountsLatestSalesActivity'] = 'toApiJson' in this.accountsLatestSalesActivity ? this.accountsLatestSalesActivity.toApiJson() : this.accountsLatestSalesActivity;
    }
    return toReturn;
  }
}
class GetSalespersonByEmailRequest {
  static fromProto(proto) {
    let m = new GetSalespersonByEmailRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.email !== 'undefined') {
      toReturn['email'] = this.email;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    return toReturn;
  }
}
class GetSalespersonByEmailResponse {
  static fromProto(proto) {
    let m = new GetSalespersonByEmailResponse();
    m = Object.assign(m, proto);
    if (proto.salesperson) {
      m.salesperson = Salesperson.fromProto(proto.salesperson);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.salesperson !== 'undefined' && this.salesperson !== null) {
      toReturn['salesperson'] = 'toApiJson' in this.salesperson ? this.salesperson.toApiJson() : this.salesperson;
    }
    return toReturn;
  }
}
class IsConfigValidRequest {
  static fromProto(proto) {
    let m = new IsConfigValidRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    return toReturn;
  }
}
class IsConfigValidResponse {
  static fromProto(proto) {
    let m = new IsConfigValidResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.isValid !== 'undefined') {
      toReturn['isValid'] = this.isValid;
    }
    return toReturn;
  }
}
class ListActionListsRequest {
  static fromProto(proto) {
    let m = new ListActionListsRequest();
    m = Object.assign(m, proto);
    if (proto.pagingOptions) {
      m.pagingOptions = PageIndexedRequestOptions.fromProto(proto.pagingOptions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    if (typeof this.searchString !== 'undefined') {
      toReturn['searchString'] = this.searchString;
    }
    return toReturn;
  }
}
class ListActionListsResponse {
  static fromProto(proto) {
    let m = new ListActionListsResponse();
    m = Object.assign(m, proto);
    if (proto.actionLists) {
      m.actionLists = proto.actionLists.map(ActionList.fromProto);
    }
    if (proto.nextPage) {
      m.nextPage = parseInt(proto.nextPage, 10);
    }
    if (proto.totalActionListsCount) {
      m.totalActionListsCount = parseInt(proto.totalActionListsCount, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.actionLists !== 'undefined' && this.actionLists !== null) {
      toReturn['actionLists'] = 'toApiJson' in this.actionLists ? this.actionLists.toApiJson() : this.actionLists;
    }
    if (typeof this.nextPage !== 'undefined') {
      toReturn['nextPage'] = this.nextPage;
    }
    if (typeof this.totalActionListsCount !== 'undefined') {
      toReturn['totalActionListsCount'] = this.totalActionListsCount;
    }
    return toReturn;
  }
}
class ListContactsForBusinessRequest {
  static fromProto(proto) {
    let m = new ListContactsForBusinessRequest();
    m = Object.assign(m, proto);
    if (proto.fieldMask) {
      m.fieldMask = FieldMask.fromProto(proto.fieldMask);
    }
    if (proto.pagingOptions) {
      m.pagingOptions = PagedRequestOptions.fromProto(proto.pagingOptions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.fieldMask !== 'undefined' && this.fieldMask !== null) {
      toReturn['fieldMask'] = 'toApiJson' in this.fieldMask ? this.fieldMask.toApiJson() : this.fieldMask;
    }
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    return toReturn;
  }
}
class ListContactsForBusinessResponse {
  static fromProto(proto) {
    let m = new ListContactsForBusinessResponse();
    m = Object.assign(m, proto);
    if (proto.contacts) {
      m.contacts = proto.contacts.map(Contact.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.contacts !== 'undefined' && this.contacts !== null) {
      toReturn['contacts'] = 'toApiJson' in this.contacts ? this.contacts.toApiJson() : this.contacts;
    }
    return toReturn;
  }
}
class ListContactsForEmailRequest {
  static fromProto(proto) {
    let m = new ListContactsForEmailRequest();
    m = Object.assign(m, proto);
    if (proto.fieldMask) {
      m.fieldMask = FieldMask.fromProto(proto.fieldMask);
    }
    if (proto.pagingOptions) {
      m.pagingOptions = PagedRequestOptions.fromProto(proto.pagingOptions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.fieldMask !== 'undefined' && this.fieldMask !== null) {
      toReturn['fieldMask'] = 'toApiJson' in this.fieldMask ? this.fieldMask.toApiJson() : this.fieldMask;
    }
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    if (typeof this.contactEmail !== 'undefined') {
      toReturn['contactEmail'] = this.contactEmail;
    }
    return toReturn;
  }
}
class ListContactsResponse {
  static fromProto(proto) {
    let m = new ListContactsResponse();
    m = Object.assign(m, proto);
    if (proto.contacts) {
      m.contacts = proto.contacts.map(Contact.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.contacts !== 'undefined' && this.contacts !== null) {
      toReturn['contacts'] = 'toApiJson' in this.contacts ? this.contacts.toApiJson() : this.contacts;
    }
    return toReturn;
  }
}
class ListRequest {
  static fromProto(proto) {
    let m = new ListRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    return toReturn;
  }
}
class ListResponse {
  static fromProto(proto) {
    let m = new ListResponse();
    m = Object.assign(m, proto);
    if (proto.requests) {
      m.requests = proto.requests.map(CancellationRequest.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.requests !== 'undefined' && this.requests !== null) {
      toReturn['requests'] = 'toApiJson' in this.requests ? this.requests.toApiJson() : this.requests;
    }
    return toReturn;
  }
}
class LookupCampaignsRequest {
  static fromProto(proto) {
    let m = new LookupCampaignsRequest();
    m = Object.assign(m, proto);
    if (proto.offset) {
      m.offset = parseInt(proto.offset, 10);
    }
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    if (typeof this.focus !== 'undefined') {
      toReturn['focus'] = this.focus;
    }
    if (typeof this.state !== 'undefined') {
      toReturn['state'] = this.state;
    }
    if (typeof this.offset !== 'undefined') {
      toReturn['offset'] = this.offset;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    if (typeof this.searchTerm !== 'undefined') {
      toReturn['searchTerm'] = this.searchTerm;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    return toReturn;
  }
}
class LookupCampaignsResponse {
  static fromProto(proto) {
    let m = new LookupCampaignsResponse();
    m = Object.assign(m, proto);
    if (proto.campaigns) {
      m.campaigns = proto.campaigns.map(SalesCampaign.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.campaigns !== 'undefined' && this.campaigns !== null) {
      toReturn['campaigns'] = 'toApiJson' in this.campaigns ? this.campaigns.toApiJson() : this.campaigns;
    }
    return toReturn;
  }
}
class GetMultiOpportunityEffortsResponseOpportunityEffortsEntry {
  static fromProto(proto) {
    let m = new GetMultiOpportunityEffortsResponseOpportunityEffortsEntry();
    m = Object.assign(m, proto);
    if (proto.value) {
      m.value = EffortAggregate.fromProto(proto.value);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.key !== 'undefined') {
      toReturn['key'] = this.key;
    }
    if (typeof this.value !== 'undefined' && this.value !== null) {
      toReturn['value'] = 'toApiJson' in this.value ? this.value.toApiJson() : this.value;
    }
    return toReturn;
  }
}
class PageIndexedRequestOptions {
  static fromProto(proto) {
    let m = new PageIndexedRequestOptions();
    m = Object.assign(m, proto);
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    if (proto.pageIndex) {
      m.pageIndex = parseInt(proto.pageIndex, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    if (typeof this.pageIndex !== 'undefined') {
      toReturn['pageIndex'] = this.pageIndex;
    }
    return toReturn;
  }
}
class PagedRequestOptions {
  static fromProto(proto) {
    let m = new PagedRequestOptions();
    m = Object.assign(m, proto);
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    return toReturn;
  }
}
class AddContactToCampaignRequestRecipient {
  static fromProto(proto) {
    let m = new AddContactToCampaignRequestRecipient();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.emailAddress !== 'undefined') {
      toReturn['emailAddress'] = this.emailAddress;
    }
    return toReturn;
  }
}
class ResendUserWelcomeEmailRequest {
  static fromProto(proto) {
    let m = new ResendUserWelcomeEmailRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.subjectId !== 'undefined') {
      toReturn['subjectId'] = this.subjectId;
    }
    return toReturn;
  }
}
class ResendUserWelcomeEmailResponse {
  static fromProto(proto) {
    let m = new ResendUserWelcomeEmailResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.notificationId !== 'undefined') {
      toReturn['notificationId'] = this.notificationId;
    }
    return toReturn;
  }
}
class SalesCampaign {
  static fromProto(proto) {
    let m = new SalesCampaign();
    m = Object.assign(m, proto);
    if (proto.campaignSchedule) {
      m.campaignSchedule = proto.campaignSchedule.map(ScheduleStep.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.campaignStatus !== 'undefined') {
      toReturn['campaignStatus'] = this.campaignStatus;
    }
    if (typeof this.campaignId !== 'undefined') {
      toReturn['campaignId'] = this.campaignId;
    }
    if (typeof this.campaignSchedule !== 'undefined' && this.campaignSchedule !== null) {
      toReturn['campaignSchedule'] = 'toApiJson' in this.campaignSchedule ? this.campaignSchedule.toApiJson() : this.campaignSchedule;
    }
    return toReturn;
  }
}
class ScheduleStep {
  static fromProto(proto) {
    let m = new ScheduleStep();
    m = Object.assign(m, proto);
    if (proto.secondsAfterLastEmail) {
      m.secondsAfterLastEmail = parseInt(proto.secondsAfterLastEmail, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.stepType !== 'undefined') {
      toReturn['stepType'] = this.stepType;
    }
    if (typeof this.secondsAfterLastEmail !== 'undefined') {
      toReturn['secondsAfterLastEmail'] = this.secondsAfterLastEmail;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.templateId !== 'undefined') {
      toReturn['templateId'] = this.templateId;
    }
    return toReturn;
  }
}
class SearchBusinessesByContactEmailRequest {
  static fromProto(proto) {
    let m = new SearchBusinessesByContactEmailRequest();
    m = Object.assign(m, proto);
    if (proto.fieldMask) {
      m.fieldMask = FieldMask.fromProto(proto.fieldMask);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.fieldMask !== 'undefined' && this.fieldMask !== null) {
      toReturn['fieldMask'] = 'toApiJson' in this.fieldMask ? this.fieldMask.toApiJson() : this.fieldMask;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    if (typeof this.contactEmailQuery !== 'undefined') {
      toReturn['contactEmailQuery'] = this.contactEmailQuery;
    }
    if (typeof this.assignedUserId !== 'undefined') {
      toReturn['assignedUserId'] = this.assignedUserId;
    }
    return toReturn;
  }
}
class SearchRequest {
  static fromProto(proto) {
    let m = new SearchRequest();
    m = Object.assign(m, proto);
    if (proto.fieldMask) {
      m.fieldMask = FieldMask.fromProto(proto.fieldMask);
    }
    if (proto.pagingOptions) {
      m.pagingOptions = PagedRequestOptions.fromProto(proto.pagingOptions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.fieldMask !== 'undefined' && this.fieldMask !== null) {
      toReturn['fieldMask'] = 'toApiJson' in this.fieldMask ? this.fieldMask.toApiJson() : this.fieldMask;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    return toReturn;
  }
}
class SearchResponse {
  static fromProto(proto) {
    let m = new SearchResponse();
    m = Object.assign(m, proto);
    if (proto.businesses) {
      m.businesses = proto.businesses.map(Business.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businesses !== 'undefined' && this.businesses !== null) {
      toReturn['businesses'] = 'toApiJson' in this.businesses ? this.businesses.toApiJson() : this.businesses;
    }
    return toReturn;
  }
}
class SendPasswordResetEmailRequest {
  static fromProto(proto) {
    let m = new SendPasswordResetEmailRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.salesPersonId !== 'undefined') {
      toReturn['salesPersonId'] = this.salesPersonId;
    }
    if (typeof this.usePlatformDefaultDomain !== 'undefined') {
      toReturn['usePlatformDefaultDomain'] = this.usePlatformDefaultDomain;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    return toReturn;
  }
}
class SetAccountPrimaryContactRequest {
  static fromProto(proto) {
    let m = new SetAccountPrimaryContactRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountId !== 'undefined') {
      toReturn['accountId'] = this.accountId;
    }
    if (typeof this.contactId !== 'undefined') {
      toReturn['contactId'] = this.contactId;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    return toReturn;
  }
}
class UpdateContactRequest {
  static fromProto(proto) {
    let m = new UpdateContactRequest();
    m = Object.assign(m, proto);
    if (proto.contact) {
      m.contact = Contact.fromProto(proto.contact);
    }
    if (proto.mutatorMask) {
      m.mutatorMask = FieldMask.fromProto(proto.mutatorMask);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    if (typeof this.contact !== 'undefined' && this.contact !== null) {
      toReturn['contact'] = 'toApiJson' in this.contact ? this.contact.toApiJson() : this.contact;
    }
    if (typeof this.mutatorMask !== 'undefined' && this.mutatorMask !== null) {
      toReturn['mutatorMask'] = 'toApiJson' in this.mutatorMask ? this.mutatorMask.toApiJson() : this.mutatorMask;
    }
    return toReturn;
  }
}
class UpdateStatusRequest {
  static fromProto(proto) {
    let m = new UpdateStatusRequest();
    m = Object.assign(m, proto);
    if (proto.status) {
      m.status = enumStringToValue(CancellationRequestStatus, proto.status);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.cancellationRequestId !== 'undefined') {
      toReturn['cancellationRequestId'] = this.cancellationRequestId;
    }
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    return toReturn;
  }
}

// *********************************

const environment = (window ? window['environment'] : 'prod') ?? 'prod';
const hostMap = {
  'local': '',
  'test': '',
  'demo': 'sales-api-demo.vendasta-internal.com',
  'prod': 'sales-api-prod.vendasta-internal.com',
  'production': 'sales-api-prod.vendasta-internal.com'
};
let HostService = /*#__PURE__*/(() => {
  class HostService {
    get host() {
      return hostMap[environment.toLowerCase()];
    }
    get hostWithScheme() {
      return 'https://' + this.host;
    }
  }
  HostService.ɵfac = function HostService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || HostService)();
  };
  HostService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: HostService,
    factory: HostService.ɵfac,
    providedIn: 'root'
  });
  return HostService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
let ActionListsApiService = /*#__PURE__*/(() => {
  class ActionListsApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    listActionLists(r) {
      const request = r.toApiJson ? r : new ListActionListsRequest(r);
      return this.http.post(this._host + "/sales.v2beta1.ActionLists/ListActionLists", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListActionListsResponse.fromProto(resp)));
    }
    addAccountsToActionList(r) {
      const request = r.toApiJson ? r : new AddAccountsToActionListRequest(r);
      return this.http.post(this._host + "/sales.v2beta1.ActionLists/AddAccountsToActionList", request.toApiJson(), this.apiOptions()).pipe(map(resp => AddAccountsToActionListResponse.fromProto(resp)));
    }
  }
  ActionListsApiService.ɵfac = function ActionListsApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || ActionListsApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  ActionListsApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: ActionListsApiService,
    factory: ActionListsApiService.ɵfac,
    providedIn: 'root'
  });
  return ActionListsApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
let BusinessApiService = /*#__PURE__*/(() => {
  class BusinessApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    search(r) {
      const request = r.toApiJson ? r : new SearchRequest(r);
      return this.http.post(this._host + "/sales.v2beta1.BusinessService/Search", request.toApiJson(), this.apiOptions()).pipe(map(resp => SearchResponse.fromProto(resp)));
    }
    searchBusinessesByContactEmail(r) {
      const request = r.toApiJson ? r : new SearchBusinessesByContactEmailRequest(r);
      return this.http.post(this._host + "/sales.v2beta1.BusinessService/SearchBusinessesByContactEmail", request.toApiJson(), this.apiOptions()).pipe(map(resp => SearchResponse.fromProto(resp)));
    }
    setAccountPrimaryContact(r) {
      const request = r.toApiJson ? r : new SetAccountPrimaryContactRequest(r);
      return this.http.post(this._host + "/sales.v2beta1.BusinessService/SetAccountPrimaryContact", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getAccountPrimaryContact(r) {
      const request = r.toApiJson ? r : new GetAccountPrimaryContactRequest(r);
      return this.http.post(this._host + "/sales.v2beta1.BusinessService/GetAccountPrimaryContact", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetAccountPrimaryContactResponse.fromProto(resp)));
    }
    getSalesActivityForAccounts(r) {
      const request = r.toApiJson ? r : new GetSalesActivityForAccountsRequest(r);
      return this.http.post(this._host + "/sales.v2beta1.BusinessService/GetSalesActivityForAccounts", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetSalesActivityForAccountsResponse.fromProto(resp)));
    }
  }
  BusinessApiService.ɵfac = function BusinessApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || BusinessApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  BusinessApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: BusinessApiService,
    factory: BusinessApiService.ɵfac,
    providedIn: 'root'
  });
  return BusinessApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
let CampaignApiService = /*#__PURE__*/(() => {
  class CampaignApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    getMultiCampaigns(r) {
      const request = r.toApiJson ? r : new GetMultiCampaignsRequest(r);
      return this.http.post(this._host + "/sales.v2beta1.CampaignService/GetMultiCampaigns", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetMultiCampaignsResponse.fromProto(resp)));
    }
    lookupCampaigns(r) {
      const request = r.toApiJson ? r : new LookupCampaignsRequest(r);
      return this.http.post(this._host + "/sales.v2beta1.CampaignService/LookupCampaigns", request.toApiJson(), this.apiOptions()).pipe(map(resp => LookupCampaignsResponse.fromProto(resp)));
    }
    addContactToCampaign(r) {
      const request = r.toApiJson ? r : new AddContactToCampaignRequest(r);
      return this.http.post(this._host + "/sales.v2beta1.CampaignService/AddContactToCampaign", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
  }
  CampaignApiService.ɵfac = function CampaignApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || CampaignApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  CampaignApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: CampaignApiService,
    factory: CampaignApiService.ɵfac,
    providedIn: 'root'
  });
  return CampaignApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
let CancellationRequestsApiService = /*#__PURE__*/(() => {
  class CancellationRequestsApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    list(r) {
      const request = r.toApiJson ? r : new ListRequest(r);
      return this.http.post(this._host + "/sales.v2beta1.CancellationRequests/List", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListResponse.fromProto(resp)));
    }
    updateStatus(r) {
      const request = r.toApiJson ? r : new UpdateStatusRequest(r);
      return this.http.post(this._host + "/sales.v2beta1.CancellationRequests/UpdateStatus", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    create(r) {
      const request = r.toApiJson ? r : new CreateRequest(r);
      return this.http.post(this._host + "/sales.v2beta1.CancellationRequests/Create", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    isConfigValid(r) {
      const request = r.toApiJson ? r : new IsConfigValidRequest(r);
      return this.http.post(this._host + "/sales.v2beta1.CancellationRequests/IsConfigValid", request.toApiJson(), this.apiOptions()).pipe(map(resp => IsConfigValidResponse.fromProto(resp)));
    }
  }
  CancellationRequestsApiService.ɵfac = function CancellationRequestsApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || CancellationRequestsApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  CancellationRequestsApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: CancellationRequestsApiService,
    factory: CancellationRequestsApiService.ɵfac,
    providedIn: 'root'
  });
  return CancellationRequestsApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
let ContactsApiService = /*#__PURE__*/(() => {
  class ContactsApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    getContactById(r) {
      const request = r.toApiJson ? r : new GetContactByIDRequest(r);
      return this.http.post(this._host + "/sales.v2beta1.Contacts/GetContactByID", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetContactResponse.fromProto(resp)));
    }
    listContactsForEmail(r) {
      const request = r.toApiJson ? r : new ListContactsForEmailRequest(r);
      return this.http.post(this._host + "/sales.v2beta1.Contacts/ListContactsForEmail", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListContactsResponse.fromProto(resp)));
    }
    listContactsForBusiness(r) {
      const request = r.toApiJson ? r : new ListContactsForBusinessRequest(r);
      return this.http.post(this._host + "/sales.v2beta1.Contacts/ListContactsForBusiness", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListContactsForBusinessResponse.fromProto(resp)));
    }
    resendUserWelcomeEmail(r) {
      const request = r.toApiJson ? r : new ResendUserWelcomeEmailRequest(r);
      return this.http.post(this._host + "/sales.v2beta1.Contacts/ResendUserWelcomeEmail", request.toApiJson(), this.apiOptions()).pipe(map(resp => ResendUserWelcomeEmailResponse.fromProto(resp)));
    }
    getContactsForAccounts(r) {
      const request = r.toApiJson ? r : new GetContactsForAccountsRequest(r);
      return this.http.post(this._host + "/sales.v2beta1.Contacts/GetContactsForAccounts", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetContactsForAccountsResponse.fromProto(resp)));
    }
    update(r) {
      const request = r.toApiJson ? r : new UpdateContactRequest(r);
      return this.http.post(this._host + "/sales.v2beta1.Contacts/Update", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    delete(r) {
      const request = r.toApiJson ? r : new DeleteContactRequest(r);
      return this.http.post(this._host + "/sales.v2beta1.Contacts/Delete", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    create(r) {
      const request = r.toApiJson ? r : new CreateContactRequest(r);
      return this.http.post(this._host + "/sales.v2beta1.Contacts/Create", request.toApiJson(), this.apiOptions()).pipe(map(resp => CreateContactResponse.fromProto(resp)));
    }
  }
  ContactsApiService.ɵfac = function ContactsApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || ContactsApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  ContactsApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: ContactsApiService,
    factory: ContactsApiService.ɵfac,
    providedIn: 'root'
  });
  return ContactsApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
let SalespeopleApiService = /*#__PURE__*/(() => {
  class SalespeopleApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    getSalespersonByEmail(r) {
      const request = r.toApiJson ? r : new GetSalespersonByEmailRequest(r);
      return this.http.post(this._host + "/sales.v2beta1.Salespeople/GetSalespersonByEmail", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetSalespersonByEmailResponse.fromProto(resp)));
    }
    createSalespersonForUser(r) {
      const request = r.toApiJson ? r : new CreateSalespersonForUserRequest(r);
      return this.http.post(this._host + "/sales.v2beta1.Salespeople/CreateSalespersonForUser", request.toApiJson(), this.apiOptions()).pipe(map(resp => CreateSalespersonForUserResponse.fromProto(resp)));
    }
    getMultiOpportunityEfforts(r) {
      const request = r.toApiJson ? r : new GetMultiOpportunityEffortsRequest(r);
      return this.http.post(this._host + "/sales.v2beta1.Salespeople/GetMultiOpportunityEfforts", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetMultiOpportunityEffortsResponse.fromProto(resp)));
    }
    sendPasswordResetEmail(r) {
      const request = r.toApiJson ? r : new SendPasswordResetEmailRequest(r);
      return this.http.post(this._host + "/sales.v2beta1.Salespeople/SendPasswordResetEmail", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
  }
  SalespeopleApiService.ɵfac = function SalespeopleApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || SalespeopleApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  SalespeopleApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: SalespeopleApiService,
    factory: SalespeopleApiService.ɵfac,
    providedIn: 'root'
  });
  return SalespeopleApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
let CancellationRequestService = /*#__PURE__*/(() => {
  class CancellationRequestService {
    constructor(svc) {
      this.svc = svc;
    }
    create(accountGroupId, partnerId, lineItemId, requestingUserId, reason, message, status) {
      const req = {
        accountGroupId: accountGroupId,
        partnerId: partnerId,
        lineItemId: lineItemId,
        requestingUserId: requestingUserId,
        status: status,
        reason: reason,
        message: message
      };
      return this.svc.create(req);
    }
    list(partnerId, accountGroupId, marketId) {
      const req = {
        partnerId: partnerId,
        accountGroupId: accountGroupId
      };
      if (!!marketId) {
        req.marketId = marketId;
      }
      return this.svc.list(req).pipe(map(resp => resp?.requests ?? []));
    }
    updateStatus(cancellationRequestId, cancellationRequestStatus, userId) {
      const req = {
        cancellationRequestId: cancellationRequestId,
        status: cancellationRequestStatus,
        userId: userId
      };
      return this.svc.updateStatus(req);
    }
    isConfigValid(partnerId, accountGroupId) {
      const req = {
        partnerId: partnerId,
        accountGroupId: accountGroupId
      };
      return this.svc.isConfigValid(req).pipe(map(resp => resp.isValid));
    }
  }
  CancellationRequestService.ɵfac = function CancellationRequestService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || CancellationRequestService)(i0.ɵɵinject(CancellationRequestsApiService));
  };
  CancellationRequestService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: CancellationRequestService,
    factory: CancellationRequestService.ɵfac,
    providedIn: 'root'
  });
  return CancellationRequestService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var Sort = /*#__PURE__*/function (Sort) {
  Sort[Sort["Updated"] = 0] = "Updated"; // Only exists to communicate that this is currently the only sort option
  return Sort;
}(Sort || {});
var SortDirection = /*#__PURE__*/function (SortDirection) {
  SortDirection[SortDirection["Descending"] = 0] = "Descending"; // Only exists to communicate that this is currently the only sort option
  return SortDirection;
}(SortDirection || {});
let BusinessService = /*#__PURE__*/(() => {
  class BusinessService {
    constructor(svc) {
      this.svc = svc;
    }
    search(partner, market, sort, direction, pageSize = 10) {
      const req = {
        partnerId: partner,
        marketId: market,
        fieldMask: {
          paths: ['external_id', 'updated']
        },
        pagingOptions: {
          pageSize: pageSize
        }
      };
      return this.svc.search(req).pipe(map(resp => this.returnBusinessResult(resp)), catchError(err => throwError(this.returnSearchError(err))));
    }
    searchBusinessesByContactEmail(partner, market, contactEmailQuery, assignedUserId) {
      const req = {
        partnerId: partner,
        marketId: market,
        contactEmailQuery: contactEmailQuery,
        fieldMask: {
          paths: ['external_id', 'updated']
        }
      };
      if (assignedUserId) {
        req.assignedUserId = assignedUserId;
      }
      return this.svc.searchBusinessesByContactEmail(req).pipe(map(resp => this.returnBusinessResult(resp)), catchError(err => throwError(this.returnSearchError(err))));
    }
    getPrimaryContact(accountId, partnerId, marketId) {
      const req = new GetAccountPrimaryContactRequest({
        accountId: accountId,
        partnerId: partnerId,
        marketId: marketId
      });
      return this.svc.getAccountPrimaryContact(req).pipe(map(resp => resp?.contactId));
    }
    setPrimaryContact(contactId, accountId, partnerId, marketId) {
      const req = new SetAccountPrimaryContactRequest({
        contactId: contactId,
        accountId: accountId,
        partnerId: partnerId,
        marketId: marketId
      });
      return this.svc.setAccountPrimaryContact(req).pipe(mapTo(null));
    }
    getLatestSalesActivityForAccounts(partnerId, marketId, accountIds) {
      const req = new GetSalesActivityForAccountsRequest({
        partnerId: partnerId,
        marketId: marketId,
        accountIds: accountIds
      });
      return this.svc.getSalesActivityForAccounts(req).pipe(map(resp => resp?.accountsLatestSalesActivity));
    }
    returnBusinessResult(resp) {
      return resp.businesses.map(b => ({
        accountGroupId: b.accountGroupId,
        updated: b.updated
      }));
    }
    returnSearchError(err) {
      if (err?.status === 404) {
        return of([]);
      }
      return err;
    }
  }
  BusinessService.ɵfac = function BusinessService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || BusinessService)(i0.ɵɵinject(BusinessApiService));
  };
  BusinessService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: BusinessService,
    factory: BusinessService.ɵfac,
    providedIn: 'root'
  });
  return BusinessService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ActionListsService = /*#__PURE__*/(() => {
  class ActionListsService {
    constructor(svc) {
      this.svc = svc;
    }
    listActionLists(partnerId, marketId, searchString, pageIndex, pageSize) {
      const req = {
        partnerId: partnerId,
        marketId: marketId,
        searchString: searchString,
        pagingOptions: {
          pageIndex: pageIndex,
          pageSize: pageSize
        }
      };
      return this.svc.listActionLists(req).pipe(catchError(err => {
        if (err.status === 404) {
          return of(new ListActionListsResponse());
        }
        throw err;
      }));
    }
    addAccountsToActionList(partnerId, marketId, listName, accountGroupIds) {
      const req = {
        partnerId: partnerId,
        marketId: marketId,
        listName: listName,
        accountGroupIds: accountGroupIds
      };
      return this.svc.addAccountsToActionList(req);
    }
  }
  ActionListsService.ɵfac = function ActionListsService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || ActionListsService)(i0.ɵɵinject(ActionListsApiService));
  };
  ActionListsService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: ActionListsService,
    factory: ActionListsService.ɵfac,
    providedIn: 'root'
  });
  return ActionListsService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ContactsService = /*#__PURE__*/(() => {
  class ContactsService {
    constructor(svc) {
      this.svc = svc;
    }
    resendUserWelcomeEmail(partnerID, subjectID) {
      const resendRequest = {
        partnerId: partnerID,
        subjectId: subjectID
      };
      return this.svc.resendUserWelcomeEmail(resendRequest).pipe(map(response => ({
        success: response.notificationId !== ''
      })));
    }
    getContactsForAccounts(partnerID, marketID, accountIDs) {
      const getContactsRequest = {
        partnerId: partnerID,
        marketId: marketID,
        accountIds: accountIDs
      };
      return this.svc.getContactsForAccounts(getContactsRequest).pipe(map(response => ({
        contacts: response?.contacts || []
      })));
    }
    create(partnerId, marketId, accountGroupIds, contactAttributes) {
      const r = new CreateContactRequest({
        partnerId: partnerId,
        marketId: marketId,
        accountGroupIds: accountGroupIds,
        title: contactAttributes.title,
        firstName: contactAttributes.firstName,
        lastName: contactAttributes.lastName,
        phoneNumber: contactAttributes.phoneNumber,
        phoneNumberCountry: contactAttributes.phoneCountryCode,
        phoneNumberExtension: contactAttributes.phoneExtension,
        email: contactAttributes.email,
        notes: contactAttributes.notes
      });
      return this.svc.create(r).pipe(map(resp => resp.contact));
    }
    update(partnerId, marketId, contact, updatedFields) {
      const updateRequest = new UpdateContactRequest({
        partnerId: partnerId,
        marketId: marketId,
        contact: contact,
        mutatorMask: new FieldMask({
          paths: updatedFields
        })
      });
      return this.svc.update(updateRequest);
    }
    delete(partnerId, marketId, contactId) {
      if (!partnerId || !marketId || !contactId) {
        throw new Error('partnerId, marketId, and contactId required to delete a contact');
      }
      const deleteRequest = new DeleteContactRequest({
        partnerId: partnerId,
        marketId: marketId,
        contactId: contactId
      });
      return this.svc.delete(deleteRequest);
    }
    listContactsForBusiness(businessId, paths) {
      if (!businessId) {
        throw new Error('businessId required to retrieve contacts for a business');
      }
      const listRequest = new ListContactsForBusinessRequest({
        fieldMask: new FieldMask({
          paths: paths
        }),
        pagingOptions: new PagedRequestOptions({
          pageSize: 100
        }),
        accountGroupId: businessId
      });
      return this.svc.listContactsForBusiness(listRequest).pipe(map(res => res.contacts));
    }
  }
  ContactsService.ɵfac = function ContactsService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || ContactsService)(i0.ɵɵinject(ContactsApiService));
  };
  ContactsService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: ContactsService,
    factory: ContactsService.ɵfac,
    providedIn: 'root'
  });
  return ContactsService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SalespeopleService = /*#__PURE__*/(() => {
  class SalespeopleService {
    constructor(svc) {
      this.svc = svc;
    }
    isPermittedToCreateSalespersonForUser(userID) {
      return this.sendCreateSalespersonForUserRequest(userID, '', false, true).pipe(mapTo(true), catchError(_ => of(false)));
    }
    createSalespersonForUser(userID, marketID, isSalesManager = false) {
      return this.sendCreateSalespersonForUserRequest(userID, marketID, isSalesManager, false);
    }
    // returns salesperson efforts stats mapped to opportunityIds
    getMultiOpportunitySalespersonEfforts(opportunityIds) {
      const req = new GetMultiOpportunityEffortsRequest({
        opportunityIds: opportunityIds
      });
      return this.svc.getMultiOpportunityEfforts(req).pipe(map(resp => resp?.opportunityEfforts));
    }
    sendCreateSalespersonForUserRequest(userID, marketID, isSalesManager = false, authCheckOnly = false) {
      const req = {
        userId: userID,
        marketId: marketID,
        isSalesManager: isSalesManager,
        authCheckOnly: authCheckOnly
      };
      return this.svc.createSalespersonForUser(req);
    }
    sendPasswordResetEmail(partnerId, salesPersonId, usePlatformDefaultDomain) {
      const req = new SendPasswordResetEmailRequest({
        partnerId: partnerId,
        salesPersonId: salesPersonId,
        usePlatformDefaultDomain: usePlatformDefaultDomain
      });
      return this.svc.sendPasswordResetEmail(req);
    }
  }
  SalespeopleService.ɵfac = function SalespeopleService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || SalespeopleService)(i0.ɵɵinject(SalespeopleApiService));
  };
  SalespeopleService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: SalespeopleService,
    factory: SalespeopleService.ɵfac,
    providedIn: 'root'
  });
  return SalespeopleService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CampaignSDKService = /*#__PURE__*/(() => {
  class CampaignSDKService {
    constructor(campaignApiService) {
      this.campaignApiService = campaignApiService;
    }
    getMultiCampaigns(partnerId, marketId, accountGroupId, campaignIds) {
      return this.campaignApiService.getMultiCampaigns({
        partnerId: partnerId,
        marketId: marketId,
        accountGroupId: accountGroupId,
        campaignIds: campaignIds
      }).pipe(map(resp => resp.campaigns));
    }
    lookupCampaigns(partnerId, marketId, searchTerm, options) {
      const request = {
        partnerId: partnerId,
        marketId: marketId
      };
      if (!!searchTerm) {
        request.searchTerm = searchTerm;
      }
      request.offset = options?.offset || request.offset;
      request.pageSize = options?.pageSize || request.pageSize;
      request.focus = options?.filters?.focus || request.focus;
      request.state = options?.filters?.state || request.state;
      request.status = options?.filters?.status || request.status;
      return this.campaignApiService.lookupCampaigns(request).pipe(map(resp => resp.campaigns));
    }
    addContactToCampaign(partnerId, marketId, campaignId, unifiedUserId, contact) {
      const request = {
        partnerId: partnerId,
        marketId: marketId,
        campaignId: campaignId,
        senderUnifiedUserId: unifiedUserId,
        contact: {
          emailAddress: contact.emailAddress,
          accountGroupId: contact.accountGroupId
        }
      };
      return this.campaignApiService.addContactToCampaign(request);
    }
  }
  CampaignSDKService.ɵfac = function CampaignSDKService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || CampaignSDKService)(i0.ɵɵinject(CampaignApiService));
  };
  CampaignSDKService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: CampaignSDKService,
    factory: CampaignSDKService.ɵfac,
    providedIn: 'root'
  });
  return CampaignSDKService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { AccountField, AccountLatestSalesActivity, ActionList, ActionListsService, AddAccountsToActionListResponse, BusinessService, CampaignSDKService, CancellationRequest, CancellationRequestReason, CancellationRequestService, CancellationRequestStatus, CancellationRequestsApiService, Contact, ContactsService, CreateSalespersonForUserResponse, EffortAggregate, IsConfigValidRequest, IsConfigValidResponse, SortDirection$1 as ListAccountSortDirection, ListActionListsResponse, PagedRequestOptions, SalespeopleService, Sort, SortDirection };
